// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a1ad21ef","814":"b4ea6a07"}[chunkId] + ".chunk.js";
};